import axios from 'axios';
import { axiosConfig as config } from 'config/axiosConfig';

const { REACT_APP_API } = process.env;
const baseUrl = `${REACT_APP_API}/organization`;


/**
 * Obtener organizaciones (con paginación y filtros)
 */
export const getAll = async ({
  page = 1,
  limit = 10,
  nit = '',
  kunnr = '',
  razonSocial = ''
}) => {

  const params = new URLSearchParams({
    page,
    limit,
    nit,
    kunnr,
    razonSocial
  });

  const { data } = await axios.get(`${baseUrl}?${params}`, config);
  return data;
};


/**
 * Crear organización
 */
export const create = async (organization) => {
  const { data } = await axios.post(baseUrl, organization, config);
  return data;
};


/**
 * Actualizar organización
 */
export const update = async ({ id, organization }) => {
  const { data } = await axios.put(`${baseUrl}/${id}`, organization, config);
  return data;
};


/**
 * Eliminar organización
 */
export const remove = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/${id}`, config);
  return data;
};


/**
 * Obtener organización por ID
 */
export const getById = async (id) => {
  const { data } = await axios.get(`${baseUrl}/${id}`, config);
  return data;
};
